import React from 'react';

const RadioGroupContext = React.createContext(null);

export default RadioGroupContext;